import { motion } from "framer-motion";
import { Key, Home, ArrowRight } from "lucide-react";

const RENTER_IMG =
  "https://images.unsplash.com/photo-1543525469-65b61cc2bc06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxwZXJzb24lMjB0YWtpbmclMjBwaG90byUyMHdpdGglMjBwaG9uZXxlbnwwfHx8fDE3ODYxNDY1NDh8MA&ixlib=rb-4.1.0&q=85";
const OWNER_IMG =
  "https://images.unsplash.com/photo-1623161551727-54c918bdcec1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxoYW5keW1hbiUyMGZpeGluZyUyMHdhbGx8ZW58MHx8fHwxNzg2MTQ2NTQ4fDA&ixlib=rb-4.1.0&q=85";

export default function Audience({ onPick }) {
  return (
    <section className="py-24 lg:py-32 border-b border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-2 gap-4 lg:gap-6">
          {/* Renters */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative rounded-sm overflow-hidden bg-primary text-primary-foreground p-8 lg:p-12 min-h-[440px] flex flex-col justify-between grain-overlay"
            data-testid="audience-renters"
          >
            <img
              src={RENTER_IMG}
              alt="Person snapping a repair photo"
              className="absolute inset-0 w-full h-full object-cover opacity-25 mix-blend-multiply"
            />
            <div className="relative">
              <div className="w-11 h-11 rounded-sm bg-white/15 grid place-items-center">
                <Key size={20} />
              </div>
              <div className="text-xs uppercase tracking-widest opacity-80 mt-6">For renters</div>
              <h3 className="font-display text-4xl lg:text-5xl font-bold mt-3 leading-none">
                Get your<br />bond back.
              </h3>
              <p className="mt-5 max-w-sm opacity-90 leading-relaxed">
                End-of-lease make-goods, wall patching, paint touch-ups and tile fixes — done fast, invoiced properly, ready for your final inspection.
              </p>
            </div>
            <button
              onClick={() => onPick("renter")}
              className="relative btn-lift bg-white text-primary rounded-sm px-5 py-3 font-medium inline-flex items-center gap-2 self-start"
              data-testid="audience-renters-cta"
            >
              I'm a renter <ArrowRight size={16} />
            </button>
          </motion.div>

          {/* Homeowners */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="relative rounded-sm overflow-hidden bg-secondary text-secondary-foreground p-8 lg:p-12 min-h-[440px] flex flex-col justify-between grain-overlay"
            data-testid="audience-owners"
          >
            <img
              src={OWNER_IMG}
              alt="Tradie repairing a wall"
              className="absolute inset-0 w-full h-full object-cover opacity-25"
            />
            <div className="relative">
              <div className="w-11 h-11 rounded-sm bg-white/10 grid place-items-center">
                <Home size={20} />
              </div>
              <div className="text-xs uppercase tracking-widest opacity-80 mt-6">For homeowners</div>
              <h3 className="font-display text-4xl lg:text-5xl font-bold mt-3 leading-none">
                Maintain<br />your asset.
              </h3>
              <p className="mt-5 max-w-sm opacity-80 leading-relaxed">
                The niggling repairs that add up. Cracked tiles, chipped benches, dodgy hinges, appliance fixes — one place, one invoice, done properly.
              </p>
            </div>
            <button
              onClick={() => onPick("homeowner")}
              className="relative btn-lift bg-primary text-primary-foreground rounded-sm px-5 py-3 font-medium inline-flex items-center gap-2 self-start"
              data-testid="audience-owners-cta"
            >
              I own the home <ArrowRight size={16} />
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
